import { render, staticRenderFns } from "./Jurisdiction.vue?vue&type=template&id=bfa26ff4&scoped=true&"
import script from "./Jurisdiction.vue?vue&type=script&lang=js&"
export * from "./Jurisdiction.vue?vue&type=script&lang=js&"
import style0 from "./Jurisdiction.vue?vue&type=style&index=0&id=bfa26ff4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfa26ff4",
  null
  
)

export default component.exports